import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { IIncidenteDTO } from "../../../../../Interfaces/hazard/IHazard";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { UsePanelEditarIncidente } from "./UsePanelEditarIncidente";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { TextField } from "@fluentui/react";



export interface IPanelEditarIncidente extends IOpenPanel{
   item:IIncidenteDTO
}
export const PanelEditarIncidente=(props:IPanelEditarIncidente)=>{
   const {request,setRequest,putEditarIncidente,loading,reset,mensaje,status} = UsePanelEditarIncidente(props)
   const onRenderFooter = useCallback(
      () => (
        <>
          <PanelFooter
            texto="Editar"
            texto2={"Salir"}
            //disableButton={disableForm}
            onClick={putEditarIncidente}
            onDismiss={() => {
               reset()
            }}
          />
        </>
      ),
      [request]
    );
   return (
      <PanelDrawer isOpen={props.isOpen} onDismiss={reset} textHeader={"Editar Incidente"} 
      status={status} mensaje={mensaje} loading={loading} onRenderFooter={onRenderFooter}>
         <TextField 
         type="text"
         label="Nombre de Incidente"
         placeholder="Ingrese Nombre de Incidente"
         autoComplete="off"
         value={request.nombreGrupoIncidente}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,nombreGrupoIncidente:newValue})}
         }}
         />
      </PanelDrawer>
   )
}